import { useContext } from 'react'

import { NotificationContext } from '~/components/Notifications/context'
import { NotificationConfig, NotificationType } from '~/types/notifications'

export const useNotification = () => {
  const { setNotification } = useContext(NotificationContext)

  const flashSuccess = (notification: Omit<NotificationConfig, 'type'>) => {
    setNotification({
      type: NotificationType.SUCCESS,
      ...notification,
    })
  }

  const flashError = (notification: Omit<NotificationConfig, 'type'>) => {
    setNotification({
      type: NotificationType.ERROR,
      ...notification,
    })
  }

  const flashInfo = (notification: Omit<NotificationConfig, 'type'>) => {
    setNotification({
      type: NotificationType.INFO,
      ...notification,
    })
  }

  const flashInfoMobile = (notification: Omit<NotificationConfig, 'type'>) => {
    setNotification({
      type: NotificationType.INFO_MOBILE,
      ...notification,
    })
  }

  const flashSuccessMobile = (notification: Omit<NotificationConfig, 'type'>) => {
    setNotification({
      type: NotificationType.SUCCESS_MOBILE,
      ...notification,
    })
  }

  return {
    flashSuccess,
    flashError,
    flashInfo,
    flashInfoMobile,
    flashSuccessMobile,
  }
}